// extracted by mini-css-extract-plugin
module.exports = {"header":"jlRZm","iconContainer":"_1RdKK","title":"_10q0q _3IeMh"};